import script from "./DiscoveryIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoveryIndex.vue?vue&type=script&setup=true&lang=js"

import "./DiscoveryIndex.vue?vue&type=style&index=0&id=c9bbef42&lang=css"
import "./DiscoveryIndex.vue?vue&type=style&index=1&id=c9bbef42&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9bbef42"]])

export default __exports__